import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {UserPermission} from '../constants';
import {type IUserAutoListItem} from '../schema';

/**
 * `getUserAutoList` request params
 * (what is used to send to server)
 */
export interface GetUserAutoListRequestOptions {
	query: string;
	permission?: UserPermission;
}

/**
 * `getUserAutoList` request
 * (what gets sent to the server)
 */
export type GetUserAutoListRequest = [
	GetUserAutoListRequestOptions['query'],
	Required<GetUserAutoListRequestOptions>['permission'],
];

/**
 * `getUserAutoList` response
 * (what comes back from the server)
 */
export type GetUserAutoListResponse = SuccessResponse<GetUserAutoListResult>;

/**
 * `getUserAutoList` result
 * (what is utilized from the server response)
 */
export type GetUserAutoListResult = IUserAutoListItem[];

export const getUserAutoListEndpoint = 'getUserAutoList';

/**
 * Autolist users
 * @param fetchParams Fetch params
 */
export const getUserAutoList = async (
	{query, permission = UserPermission.READ}: GetUserAutoListRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetUserAutoListRequest = [query, permission];

	return client
		.post<GetUserAutoListResponse>(getUserAutoListEndpoint, requestParams, {
			signal,
		})
		.then(getResponseResults);
};
export default getUserAutoList;
